module.exports = __webpack_public_path__ + "static/media/edit.11722b19.svg";